// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"46":"SapiMagicSortOverlay","764":"payment"}[chunkId] + "." + {"46":"5a2f9b7f","764":"ee3f0739"}[chunkId] + ".chunk.css";
};